import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useTranslation } from '../useTranslation';

const Musee = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = "musee";

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from("category_images")
          .select("id, url, category")
          .eq("category", category);

        if (error) throw error;
        setImages(data);
      } catch (err) {
        console.error("Erreur de chargement des images :", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
     <style>{`
    body {
      background: #0c0b09;
    }
  `}</style>

      <section id="events" className="events">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
          <h2>{t('museumTitle')}</h2>
<p>{t('museumSubtitle')}</p>
          </div>
          <div className="events-slider swiper-container" data-aos="fade-up" data-aos-delay="100">
            <div className="swiper-wrapper">
              {['birthday', 'private', 'custom'].map((eventType) => (
                <div className="swiper-slide" key={eventType}>
                  <div className="row event-item">
                    <div className="col-lg-6">
                       <img 
                        src={`assets/img/event.jpg`} 
                        className="img-fluid event-image"
                        alt={`${eventType} event`}
                        style={{
                          width: '100%',
                          height: '400px',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
                    </div>
                    <div className="col-lg-6 pt-4 pt-lg-0 content">
  <h3>{t('ourMuseum')}</h3>
{/* <div className="price">
    <p><span>{t('museumTheme')}</span></p>
  </div>*/} 
  <p className="fst-italic">
    {t('museumDescription')}
  </p>
  <ul>
    <li><i className="bi bi-check-circle"></i> {t('museumFeature1')}</li>
    <li><i className="bi bi-check-circle"></i> {t('museumFeature2')}</li>
    <li><i className="bi bi-check-circle"></i> {t('museumFeature3')}</li>
  </ul>
  <p>
    {t('museumConclusion')}
  </p>
</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>

      <section id="gallery" className="gallery">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('museumGalleryTitle')}</h2>
<p>{t('museumGallerySubtitle')}</p>
          </div>
        </div>
        <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
          {loading ? (
<p className="text-center">{t('loadingImages')}</p>
          ) : images.length === 0 ? (
<p className="text-center">{t('noMuseumImages')}</p>
          ) : (
            <div className="row g-0">
              {images.map((image) => (
                <div className="col-lg-3 col-md-4" key={image.id}>
                  <div className="gallery-item">
                    <a
                      href={image.url}
                      className="gallery-lightbox"
                      data-gall="gallery-item">
                      <img
                        src={image.url}
                        alt={`Image de la catégorie ${category}`}
                        className="img-fluid gallery-image"
                        style={{
                          width: '100%',
                          height: '300px',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Musee;